<clr-datagrid [clrDgLoading]="loading" *transloco="let loco; prefix: 'pages.comments'">

  <clr-dg-column [clrDgField]="'comment_type'">{{ loco('document') }}</clr-dg-column>
  <clr-dg-column [clrDgField]="'staff_id'">{{ loco('note') }}</clr-dg-column>
  <clr-dg-column [clrDgField]="'person_id'">{{ loco('contact') }}</clr-dg-column>
  <clr-dg-column [clrDgField]="'remember'" [clrDgSortOrder]="descSort">{{ loco('remember') }}</clr-dg-column>

  <clr-dg-placeholder>Aktuell keine Kommentare gefunden!</clr-dg-placeholder>
  <clr-dg-row *clrDgItems="let t of combinedComments" >
    // Project
    <ng-container *ngIf="t.comment_type === 9">
      <clr-dg-cell [routerLink]="['/' + loco('url' + '.' + t.comment_type.toString()) + '/details', splitProjectNumber(t.project, 0), splitProjectNumber(t.project, 1) ]">{{ loco('category' + '.' + t.comment_type.toString()) }} {{ t.project }}</clr-dg-cell>
    </ng-container>
    // Project
    <ng-container *ngIf="t.comment_type < 9">
      <clr-dg-cell [routerLink]="['/' + loco('url' + '.' + t.comment_type.toString()) + '/details', t.project, t.sub_id ]">{{ loco('category' + '.' + t.comment_type.toString()) }} {{ t.project }}.000{{ t.comment_type }}.{{ t.sub_id }}</clr-dg-cell>
    </ng-container>

    <clr-dg-cell>{{ t.reason }}<br>({{ t.entry | date: "dd.MM.yyyy" }}, {{ t.staff_firstname }} {{ t.staff_lastname }}) </clr-dg-cell>
    <clr-dg-cell [routerLink]="['/person/details', t.person_id ]"><span *ngIf="t.person_id > 0">{{ t.person_salutation }} {{ t.person_lastname }}</span></clr-dg-cell>
    <clr-dg-cell [className]="findButtonClass(t.remember)" role="alert">
      <cds-icon *ngIf="dateDiff(t.remember) > 0 " class="alert-icon" shape="exclamation-circle"></cds-icon>
      <cds-icon *ngIf="((dateDiff(t.remember) > -5) && (dateDiff(t.remember) <= 0))" class="alert-icon" shape="exclamation-triangle"></cds-icon>
      {{ t.remember | date: "dd.MM.yyyy" }}
    </clr-dg-cell>
  </clr-dg-row>

  <clr-dg-footer>
    <clr-dg-pagination #pagination [clrDgPageSize]="10">
      {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
      von {{ combinedComments.length }} Kommentar(en)
    </clr-dg-pagination>
  </clr-dg-footer>
</clr-datagrid>

<!--<pre *ngIf="devMode" class="datepicker-output">{{ combinedComments | json }} </pre>
<pre *ngIf="devMode" class="datepicker-output">{{ commentsData | json }} </pre>-->

